exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-1 {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-gap: 1rem;\n    grid-template-columns: repeat(3, 1fr);\n}\n.card-p{ \n    background-color: #FFF;\n    color: #4A4A4A;\n    max-height: 22.25rem;\n    max-width: 22.25rem;\n}\n.card-p-img { max-height: 16.438rem; max-width: 100%; margin: 0;\n}\n.card-p-constainer { max-height: 7rem; padding: 2rem 2rem 2rem 2rem;\n}\n@supports(object-fit: cover){\n.card-p-img img{\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c64a040","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/politicasArea.vue
// module id = x1Gf
// module chunks = 0